import { local as localStorage } from '@packages/domain/utils/storage/local';
import unset from 'lodash/unset';
import {
  getFeatures,
  getFieldValue,
  getKeepSession,
  getTheme,
  getUser,
  isEmbedded,
} from 'selectors';

const KEY = '__payex_state';

export const loadStateFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem(KEY);

    if (serializedState === null) {
      return undefined;
    }

    return JSON.parse(serializedState);
  } catch (_err) {
    return undefined;
  }
};

export const saveStateToLocalStorage = (state: any) => {
  try {
    const serializableState = {
      entities: {
        user: getUser(state),
      },
      features: getFeatures(state),
      ui: {
        embedded: isEmbedded(state),
        authentication: { keepSession: getKeepSession(state) },
        fieldValues: {
          recipient: getFieldValue(state, 'recipient'),
        },
        theme: getTheme(state),
      },
    };

    localStorage.setItem(KEY, JSON.stringify(serializableState));
  } catch (_e) {
    // do nothing
  }
};

export const removeLocalStorageUserKey = () => {
  const state = loadStateFromLocalStorage();
  unset(state, 'entities.user');

  localStorage.setItem(KEY, JSON.stringify(state));
};
